import { render, staticRenderFns } from "./PromoItemGroupModal.vue?vue&type=template&id=1c6e13d3"
import script from "./PromoItemGroupModal.vue?vue&type=script&lang=js"
export * from "./PromoItemGroupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports